import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import Roman from 'roman-numerals';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { ALLGEMEINE_HINWEISE_FELDERNAME, ANTRAG_VERBUNDPARTNER } from '../../../../../../lib/constants/componentsPath';
import { ANTRAG_TYP, BEIHILFERELEVANZ_ERFORDERLICHKEIT, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { checkIfAnyBeihilferelevanzHasComment, checkIfSelectedBeihilferelevanzHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import BeihilferelevanzErklaerungenGlobal, { getFormStrucBeihilferelevanzErklaerungGlobal } from './content/BeihilferelevanzErklaerungenGlobal';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getAntragstellerName, getVerbundPartnerName } from '../../../application-helper-function/AppHelperfunctions';
const P = Schema.attributes;
const BEIHILFERELEVANZ_HINWEISE_PATH = 'attributes.Hinweise';

export const TreeStructureSelbstErklaerungBeihilferelevanzGlobal = (
	application: any,
	readOnly: boolean,
	allgemeineHinweisBeihilferelevanz: any,
) => {
	let treeNodes: TreeNodeType[] = [];

	const anzahlHinweis =
		get(allgemeineHinweisBeihilferelevanz, BEIHILFERELEVANZ_HINWEISE_PATH, []).length > 0
			? get(allgemeineHinweisBeihilferelevanz, BEIHILFERELEVANZ_HINWEISE_PATH, []).length
			: 0;

	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const selbsterklaerungErforderlichkeit = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_Beihilferelevanz_Selbsterklaerung_Erforderlichkeit.path,
		'',
	);
	const showBeihilferelevanzErklaerung = shouldShowBeihilferelevanzErklaerung(antragsTyp, selbsterklaerungErforderlichkeit);

	// // DEBUG: Log Beihilferelevanz visibility
	// console.log('=== [Beihilferelevanz Debug] ===');
	// console.log('antragsTyp:', antragsTyp);
	// console.log('Foerderprogramm ID:', get(application, `${P.Foerderprogramm.path}.id`, 'N/A'));
	// console.log('Foerderprogramm Titel:', get(application, `${P.Foerderprogramm.path}.Allgemein_Titel_Deutsch`, 'N/A'));
	// console.log('Konfiguration_Beihilferelevanz_Selbsterklaerung_Erforderlichkeit:', selbsterklaerungErforderlichkeit || '(empty)');
	// console.log('shouldShowBeihilferelevanzErklaerung:', showBeihilferelevanzErklaerung);
	// console.log('allgemeineHinweisBeihilferelevanz data:', allgemeineHinweisBeihilferelevanz);
	// console.log('anzahlHinweis:', anzahlHinweis);
	// console.log('Beihilferelevanz_Selbsterklaerung array length:', get(application, P.Beihilferelevanz_Selbsterklaerung.path, []).length);
	// console.log('Full Foerderprogramm Konfiguration:', get(application, P.Foerderprogramm.path, {}));
	// console.log('=== [End Beihilferelevanz Debug] ===');

	if (showBeihilferelevanzErklaerung) {
		const antragstellerName = getAntragstellerName(application);
		treeNodes = [
			{
				label: 'Erklärung Beihilferelevanz',
				content: <ApplicationHeading title='Erklärung Beihilferelevanz' description={PLATZHALTER_TEXT} />,
				hasComment: checkIfAnyBeihilferelevanzHasComment(readOnly, application),
				children: [
					...get(allgemeineHinweisBeihilferelevanz, BEIHILFERELEVANZ_HINWEISE_PATH, []).map((ele: any, i: number) => ({
						label: `${Roman.toRoman(i + 1)}. ${get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Titel)}`,
						content: (
							<>
								<Box sx={{ mt: '1rem' }}>
									<Typography variant='h3' component={'h3'}>
										{get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Untertitel, '')}
									</Typography>
									<MarkdownRenderer markdown={get(ele, ALLGEMEINE_HINWEISE_FELDERNAME.Inhalt, '')} />
								</Box>
							</>
						),
					})),
					{
						label: `${Roman.toRoman(anzahlHinweis + 1)}. Beihilferelevanz-Erklärung: ${antragstellerName}`,
						content: (
							<BeihilferelevanzErklaerungenGlobal
								unternehmenId={get(application, `${P.Antragstellende_Organisation.path}.id`)}
								unternehmenName={antragstellerName}
								hasComment={checkIfSelectedBeihilferelevanzHasComment(
									readOnly,
									application,
									get(application, `${P.Antragstellende_Organisation.path}.id`),
								)}
							/>
						),
						formStruc: getFormStrucBeihilferelevanzErklaerungGlobal(
							application,
							get(application, `${P.Antragstellende_Organisation.path}.id`),
						),
						hasComment: checkIfSelectedBeihilferelevanzHasComment(
							readOnly,
							application,
							get(application, `${P.Antragstellende_Organisation.path}.id`),
						),
					},
					...get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
						const hasCommentBeihilferelevanzVerbundpartner = checkIfSelectedBeihilferelevanzHasComment(
							readOnly,
							application,
							get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`),
							get(ele, ANTRAG_VERBUNDPARTNER.PositionID),
						);

						const vPartnerName = getVerbundPartnerName(ele, i);

						return {
							label: `${Roman.toRoman(i + anzahlHinweis + 2)}. Beihilferelevanz-Erklärung: ${vPartnerName}`,
							content: (
								<BeihilferelevanzErklaerungenGlobal
									unternehmenId={get(ele, `${ANTRAG_VERBUNDPARTNER.Partner}.id`)}
									positionId={get(ele, ANTRAG_VERBUNDPARTNER.PositionID)}
									unternehmenName={vPartnerName}
									hasComment={hasCommentBeihilferelevanzVerbundpartner}
								/>
							),
							formStruc: getFormStrucBeihilferelevanzErklaerungGlobal(
								application,
								get(ele, `id`),
								get(ele, ANTRAG_VERBUNDPARTNER.PositionID),
							),
							hasComment: hasCommentBeihilferelevanzVerbundpartner,
						};
					}),
				],
			},
		];
	}

	return treeNodes;
};

function shouldShowBeihilferelevanzErklaerung(typ: string, erforderlichkeit: string) {
	if (erforderlichkeit === BEIHILFERELEVANZ_ERFORDERLICHKEIT.NichtErforderlich) return false;
	if (erforderlichkeit === BEIHILFERELEVANZ_ERFORDERLICHKEIT.InAntragUndSkizze) return true;
	if (typ === ANTRAG_TYP.Skizze) return erforderlichkeit === BEIHILFERELEVANZ_ERFORDERLICHKEIT.NurInSkizze;
	if (typ === ANTRAG_TYP.Antrag) return erforderlichkeit === BEIHILFERELEVANZ_ERFORDERLICHKEIT.NurImAntrag;

	return false;
}
